import React, { useContext, useEffect, useRef } from "react";
import styles from "./Btn.module.scss";
import PathContext from "../../context/path";
const Btn = (props) => {
  const path = useContext(PathContext);
  const {theme} = props;
  const refWrap = useRef(null);
  useEffect(()=>{
    if(styles[`wrap_${theme}`] !== undefined){
      refWrap.current.classList.add(styles[`wrap_${theme}`]);
    }
  },[theme]);
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
      {props.children}
      <div className={styles.bg}></div>
      </div>
    </>
  );

}

export default Btn;
